<script setup lang="ts">

import { ref, watch } from 'vue';
import AssetQuantileTimePlot from './AssetQuantileTimePlot.vue';
import { Quantiles } from '../fin/quantile';
import { TimeSeries, TimeSeriesS } from '../fin/history';

interface Props {
  assetTimeQuantilesSeriess: TimeSeriesS<Quantiles>;
  birthYear: number;
  retirementYear: number;
  maxYear: number;
}

const {
  assetTimeQuantilesSeriess = new TimeSeriesS<Quantiles>([]),
  birthYear=0,
  retirementYear=0,
  maxYear = 0,
} = defineProps<Props>();

const selectedAssetQuantileSeries = ref(
  selectQuantileSeries(assetTimeQuantilesSeriess)
);

watch(() => assetTimeQuantilesSeriess, (newVal, _old) => {
  selectedAssetQuantileSeries.value = selectQuantileSeries(newVal);
});

function selectQuantileSeries(
  all: TimeSeriesS<Quantiles>
): TimeSeries<Quantiles> {
  const selected = all.data.filter(s => s.name == 'ALL_SAVINGS')[0]!;
  return selected;
}

</script>

<template>
  <AssetQuantileTimePlot
    :series="selectedAssetQuantileSeries"
    :birthYear="birthYear"
    :retirementYear="retirementYear"
    :maxYear="maxYear" />
</template>

<style scoped>
</style>
